module.exports = __webpack_public_path__ + "media/images/bg_illustration-v2-ca850c9728e8abe908ffc2c31b718a49.svg";